import React from 'react'
import {createRoot} from 'react-dom/client'
import 'symbol-observable'
import {Provider} from 'react-redux'
import {ConnectedUIRouter} from '@uirouter/redux/lib/react'
import store from 'redux/config'
import routerConfig from 'router/config'
import {OktaAuth} from '@okta/okta-auth-js'
import oktaConfig from 'okta.config'
import {isAuthenticationEnabled} from 'helpers/security'

import {
  getTabTotalsHook,
  getHomeStatsHook,
  getHomeStatsExitHook,
  handleAuthenticationCriteria,
  handleAuthenticationHook,
  handleLoginCallbackCriteria,
  handleLoginCallbackHook,
} from 'router/transitionHooks/common.hooks'
import {getDatabasesHook} from 'router/transitionHooks/databases.hooks'
import {getJobsHook} from 'router/transitionHooks/jobs.hooks'
import {getDiagnosticsHook} from 'router/transitionHooks/diagnostics.hooks'

import SecurityContextProvider from 'components/containers/Security.context'
import App from 'App'
import {jobRequestCleanup} from './router/transitionHooks/jobRequests.hooks'

const authClient: typeof OktaAuth = new OktaAuth(oktaConfig)

const rootNode = document.getElementById('root')

if (!rootNode) throw new Error('Failed to find the root element')

const isSecure = isAuthenticationEnabled()

// register transition hooks
if (isSecure) {
  routerConfig.router.transitionService.onBefore(handleAuthenticationCriteria, handleAuthenticationHook(authClient))
  routerConfig.router.transitionService.onBefore(handleLoginCallbackCriteria, handleLoginCallbackHook(authClient))
}
routerConfig.router.transitionService.onStart(getTabTotalsHook.criteria, getTabTotalsHook.callback)
routerConfig.router.transitionService.onStart(getHomeStatsHook.criteria, getHomeStatsHook.callback)
routerConfig.router.transitionService.onExit(getHomeStatsExitHook.criteria, getHomeStatsExitHook.callback)
routerConfig.router.transitionService.onStart(getDatabasesHook.criteria, getDatabasesHook.callback)
routerConfig.router.transitionService.onStart(getJobsHook.criteria, getJobsHook.callback)
routerConfig.router.transitionService.onFinish(jobRequestCleanup.criteria, jobRequestCleanup.callback)
routerConfig.router.transitionService.onStart(getDiagnosticsHook.criteria, getDiagnosticsHook.callback)

const {router, states, plugins} = routerConfig

const root = createRoot(rootNode)
root.render(
  <Provider store={store}>
    <ConnectedUIRouter router={router} states={states} plugins={plugins}>
      {isSecure
        ? <SecurityContextProvider authClient={authClient}>
          <App />
        </SecurityContextProvider>
        : <App />
      }
    </ConnectedUIRouter>
  </Provider>
)
